import React from 'react';
import content from '../../../../content/main.archie';
import Markdown from 'react-remarkable';
import SizeGiver from '../../../containers/SizeGiver/SizeGiver.jsx';
import PieChart from '../../charting/PieChart/PieChart.jsx';
import SVGChart from '../../charting/SVGChart/SVGChart.jsx';
import SubInset from '../../SubInset/SubInset.jsx';
import {contentToText} from '../../../utils/helpers.jsx';
const chartstyles= {
    width   : "100%",
    height  : "0.8w",
    paddingLeft : 50,
    paddingRight: 50,
    paddingTop: 0,
    paddingBottom: 0
};


const piedata = {
    data: [
        {
            name: "Maritime",
            value: 42,
            color: "#009688"
        },
        {
            name: "Civil aviation",
            value: 1,
            color: "#e5ce89"
        },
        {
            name: "Public electricity generation",
            value: 9,
            color: "#e5982b"
        },
        {
            name: "Road transport",
            value: 21,
            color: "#5b0003"
        },
        {
            name: "Other",
            value: 26,
            color: "#cccccc"
        }
    ]
}

let componentRegistry = {
    "breakdown": (<div className="hongkong-breakdown"><SubInset hed="PM2.5 Contribution by Sector"
        source="Source: Hong Kong Environmental Protection Department"
        >
            <PieChart {...chartstyles} {...piedata}>
                <div style={{display:"table",width:"100%",height:"100%",textAlign:"center"}}>
                    <div style={{display:"table-cell",verticalAlign:"middle"}}>
                        <strong>Total:</strong><br/>
                        500 blargs
                    </div>
                </div>
            </PieChart>
        </SubInset></div>)
}



export default class HongKongProfile extends React.Component {
    render() {
        return <div className="section card-panel" style={{backgroundColor:"#fff",paddingLeft:"1rem",paddingRight:"1rem"}}>
            <div className="profile-title">Hong Kong, China (4th busiest port in the world)</div>
            <Markdown>
            { contentToText(content['hong-kong-profile'],componentRegistry) }    
            </Markdown>
            <div style={{clear:"both"}}/>
        </div>
    }   
}

        


// WEBPACK FOOTER //
// ./src/js/components/special/PortCityProfiles/HongKongProfile.jsx